import React from "react";
import PropTypes from "prop-types";
import { Button, ModalFooter } from "reactstrap";

const propTypes = {
  result: PropTypes.shape({
    action: PropTypes.string.isRequired,
    cancel_code: PropTypes.string,
    store_credit_amount: PropTypes.string,
    group_status: PropTypes.string,
    discount: PropTypes.number
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

const ConfirmationStep = ({ result, onClose }) => {
  const renderContent = () => {
    switch (result.action) {
      case "cancelled":
        return (
          <div>
            <div className="notifications success mb-3">Your campaign has been cancelled.</div>
            {result.cancel_code && (
              <p>
                <strong>Confirmation Number:</strong> {result.cancel_code}
              </p>
            )}
            {result.store_credit_amount && (
              <p>A credit of {result.store_credit_amount} has been added to your account.</p>
            )}
            <p>You will receive an email for your records.</p>
            {result.group_status === "cancel_hold" && (
              <p className="text-muted">
                Your zip code spots have been put on hold and will be released when you purchase a
                new campaign in these zip codes.
              </p>
            )}
          </div>
        );

      case "renewal_disabled":
        return (
          <div className="notifications success mb-3">
            Automatic renewal has been successfully disabled. Your campaign will continue running
            until the end of the current term.
          </div>
        );

      case "coupon_applied":
        return (
          <div className="notifications success mb-3">
            {result.discount
              ? `A ${result.discount}% discount has been applied to your next renewal.`
              : "Your discount has been applied. Your campaign will continue."}
          </div>
        );

      case "kept":
        return (
          <div className="notifications success mb-3">Your campaign will continue running.</div>
        );

      default:
        return (
          <div className="notifications danger mb-3">
            <div className="notifications__error-message">
              Something went wrong. Please contact support.
            </div>
          </div>
        );
    }
  };

  return (
    <div>
      {renderContent()}
      <ModalFooter className="pt-2 px-0">
        <Button color="primary" className="btn-sharp" onClick={onClose}>
          OK
        </Button>
      </ModalFooter>
    </div>
  );
};

ConfirmationStep.propTypes = propTypes;

export default ConfirmationStep;
